/**
 * Utilitaire de débogage pour le worker Frontend
 * Version locale qui évite les problèmes d'import
 */

export default {
  // Log uniquement si le mode debug est activé
  log: (env, message, data) => {
    if (env?.DEBUG_MODE === 'true') {
      if (data) {
        console.log(`[DEBUG] ${message}`, data);
      } else {
        console.log(`[DEBUG] ${message}`);
      }
    }
  },
  
  // Avertissement uniquement si le mode debug est activé
  warn: (env, message, data) => {
    if (env?.DEBUG_MODE === 'true') {
      if (data) {
        console.warn(`[WARN] ${message}`, data);
      } else {
        console.warn(`[WARN] ${message}`);
      }
    }
  },
  
  // Succès uniquement si le mode debug est activé
  success: (env, message, data) => {
    if (env?.DEBUG_MODE === 'true') {
      if (data) {
        console.log(`[DEBUG] ${message}`, data);
      } else {
        console.log(`[DEBUG] ${message}`);
      }
    }
  },
  
  // Erreur - toujours affichée, mais formatée différemment en mode debug
  error: (env, message, error) => {
    if (env?.DEBUG_MODE === 'true') {
      console.error(`[ERROR] ${message}`, error);
    } else {
      console.error(message);
    }
  }
};
